import React from "react"
import { Container, Row, Col, Table, Button, Spinner, Image } from "react-bootstrap"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import { Subscription } from "rxjs"
import { toast } from "react-toastify"
import { FaFileCsv, FaSync } from "react-icons/fa"
import { OrderResultGridResponse, ColumnFilters } from "../../api/OrderResults/OrderResultModel/OrderResultGridResponse"
import OrderResultRecordIdentifier from "../../api/OrderResults/OrderResultModel/OrderResultRecordIdentifier"
import OrderResultRecord, { RAImage } from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import { Sort, Filter } from "../../api/GridRequest"
import { ResultsGridObservable, OrderResultsPrint } from "../../api/OrderResults/OrderResultsListGet"
import ResultsWatchObservable from "../../api/OrderResults/ResultsWatch"
import { SearchFieldsGet } from "../../api/OrderResults/SearchFieldsGet"
import SearchField from "../../api/SearchField"
import SearchBar from "../SearchBar"
import ColumnsCustomizeModal from "../ColumnsCustomizeModal/ColumnsCustomizeModal"
import CompleteModal from "./CompleteModal"
import { CustomizableFilterColumn } from "../ColumnsCustomizeModal/CustomizableColumn"
import ColumnHeaderFilter from "../ColumnHeaderFilter"
import TablePagination from "../TablePagination"
import EmployeeDetailsModal from "./EmployeeDetailsModal"
import EventDetailsModal from "./EventDetailsModal"
import GridStatusInfo from "./GridStatusInfo"
import ModalStatusInfo from "./ModalStatusInfo"
import FormatDate from "../../formatters/FormatDate"
import FormatSSN from "../../formatters/FormatSSN"
import FormatTimestampFileName from "../../formatters/FormatTimestampFileName"
import Checkbox from "../Checkbox"
import ImageCCF from "../../assets/images/CCF.png"
import ImageMRO from "../../assets/images/MRO.png"
import ImageOHS from "../../assets/images/OHS.png"
import { AppState } from "../../AppState"
import { connect } from "react-redux"
import ImageGet, { ImageData, GetMROLetter, GenerateMROReport, TestReleaseStatusID } from "../../api/OrderResults/GenerateCCFImage"
import { APIError } from "../../api/ObservableFromFetch"
import FormatData from "../../formatters/FormatBase64"
import { isPortalAdmin } from "../../authentication/isAdminRole"
import { AccountTypeID, ImplementationTypeGovt, ScheduleStatus, StorageKey } from "../../config/Constants"
import { loadCustomized } from "../ColumnsCustomizeModal/ColumnsCustomizeModal"
import { getLoggedInUserName } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import ResultsResolveObservable from "../../api/OrderResults/ResultsResolve"
import { BuildUserAccess } from "../../authentication/BuildUserAccess"
import { ServiceTypeCode } from '../../api/Administration/Model/ServiceType';
import printPdf from "../../utils/printPdf"
import { TestTypes } from "../../api/Administration/Model/TestType"
import OrderTrackingCheckbox from "./OrderTrackingCheckbox"
import ConnectedAuthFormModal from "./AuthFormModal"
import OrderEditModal from "./OrderEditModal"
import SendSelectClinicLink from "./SendSelectClinicLink"
import ImageAlert from "../../assets/images/alert.png"
import ImageAlertResolved from "../../assets/images/alert-resolved.png"
import EventDetailsCompare from "./EventDetailsCompare"
import SearchTestToMerge from "./SearchTestToMerge"
import PrintFormModal from "./PrintFormModal"
import ReasonForTestCell from "./ReasonForTestCell"
import ExportCSVModal from "./ExportCSVModal"
import WatchCell from "./WatchCell"
import ActionButton from "../ActionButton"
import HorizontalScrollWrapper from "../HorizontalScrollWrapper"
import FormFoxTestANColumn from "./FormFoxTestANColumn"

type Column = CustomizableFilterColumn<keyof OrderResultRecord, keyof ColumnFilters>

interface OrderTrackingProps {
  isPortalAdmin: boolean
  canCompleteEvents?: boolean
  canVieweCCFCopy2PreMRO?: boolean
  LoginName: string
  implementationType: string
}

interface OrderTrackingState {
  loading: boolean
  data?: OrderResultGridResponse
  columns: Column[]
  showStatusModal: boolean
  searchField: string
  searchText: string
  showArchivedOrders: boolean
  sort?: Sort
  filters: Filter[]
  pageNumber: number
  showExportOptions: boolean
  selectedTests: OrderResultRecordIdentifier[]
  customizeModal: boolean
  completeModal: boolean
  searchFields?: SearchField[]
  statusInfo: boolean
  employeeDetails: boolean
  eventDetails: boolean
  details?: OrderResultRecord
  updatingWatchList: boolean
  resolving: boolean
  showAuthFormModal: boolean
  showResendAuth: boolean
  showOrderEditModal: boolean
  eventCompare: boolean
  showMergeEvent: boolean
  printing: boolean
  showSelectClinicEmail: boolean
}

const defaultColumns: Column[] = [
  { name: "DonorID", filter: "IDNumber", label: "ID NUMBER", visible: true, customize: false },
  { name: "DonorName", filter: "Name", label: "NAME", visible: true, customize: true },
  { name: "Service", filter: "Service", label: "SERVICE", visible: true, customize: true },
  { name: "Result", filter: "Result", label: "SAMPLE RESULT", visible: true, customize: true },
  { name: "Status", label: "STATUS", visible: true, customize: true },
  { name: "CompanyName", filter: "Company", label: "COMPANY", visible: true, customize: true },
  { name: "RegionName", filter: "Region", label: "COMPANY REGION", visible: false, customize: true },
  { name: "LocationName", filter: "Location", label: "COMPANY LOCATION", visible: false, customize: true },
  { name: "RAImageID", label: "eDocs", visible: true, customize: true },
  { name: "DOT", filter: "Regulated", label: "REGULATED", visible: true, customize: true },
  { name: "FormFoxTestAN", filter: "AuthorizationID", label: "AUTHORIZATION ID", visible: true, customize: true },
  { name: "SampleID", filter: "SampleID", label: "SAMPLE ID", visible: true, customize: true },
  { name: "OrderedDate", filter: "OrderDate", label: "ORDER DATE", visible: true, customize: true },
  { name: "SiteName", filter: "Clinic", label: "CLINIC", visible: true, customize: true },
  { name: "LabAccountNumber", filter: "LabAccountNumber", label: "LAB ACCOUNT", visible: false, customize: true },
  { name: "OrderedBy", filter: "OrderedBy", label: "ORDERED BY", visible: false, customize: true },
  { name: "OrderUpdatedBy", filter: "OrderUpdatedBy", label: "UPDATED BY", visible: true, customize: true },
  { name: "OrderUpdatedAt", filter: "OrderUpdatedAt", label: "UPDATE DATE", visible: true, customize: true },
  { name: "EventDate", filter: "EventDate", label: "COLLECTION DATE", visible: false, customize: true },
  { name: "CollectionTime", filter: "CollectionTime", label: "COLLECTION TIME", visible: false, customize: true },
  { name: "Reason", filter: "Reason", label: "REASON FOR TEST", visible: true, customize: true },
  { name: "MarketPlaceOrderNum", filter: "MarketPlaceOrderNum", label: "MPO#", visible: false, customize: true },
]

const GridIDNumber = (props: { value: OrderResultRecord }) => {
  const idType = (type: string) => {
    switch (type) {
      case "SSN":
        return "SSN";
      case "DriverID":
        return "CL";
      case "EmployeerID":
        return "EID";
      case "AlternateID":
        return "Alt";
      default: return type;
    }
  }

  const idRow = (idValue: string, idType: string, mockId:string="") => {
    return <><Button variant="link" className="btn-service" title={mockId}>{idValue}</Button><span className="align-middle text-bold">{idType}</span></>
  }
  const value = props.value
  return (
    <Row><Col>{idRow(value.DonorID, idType(value.IDType), value.MockDonorID)}</Col></Row>
  )
}

const PageSize = 40

type ReportProps = {
  canView: boolean
  canDownload: boolean
  MROReport: boolean
  MROStage: string
}

export class OrderTracking extends React.PureComponent<OrderTrackingProps, OrderTrackingState> {
  subscription?: Subscription
  searchFieldsSubscription?: Subscription
  loadImageSubscription?: Subscription
  loadReportSubscription?: Subscription
  watchSubscription?: Subscription
  resolveSubscription?: Subscription

  state: OrderTrackingState = {
    loading: false,
    data: undefined,
    columns: loadCustomized(StorageKey.OrderTrackingGridColumns, defaultColumns) as Column[],
    showStatusModal: false,
    searchField: "",
    searchText: "",
    showArchivedOrders: false,
    showExportOptions: false,
    sort: undefined,
    filters: [],
    pageNumber: 1,
    selectedTests: [],
    customizeModal: false,
    completeModal: false,
    statusInfo: false,
    employeeDetails: false,
    eventDetails: false,
    updatingWatchList: false,
    resolving: false,
    showAuthFormModal: false,
    showResendAuth: false,
    showOrderEditModal: false,
    eventCompare: false,
    showMergeEvent: false,
    printing: false,
    showSelectClinicEmail: false
  }

  gridRef = React.createRef<HTMLTableElement>()

  componentDidMount() {
    this.refreshGrid()
    this.searchFieldsSubscription = SearchFieldsGet().subscribe(
      (data: SearchField[]) => this.setState({ searchFields: data }),
      error => toast.error(error)
    )
  }

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
    this.searchFieldsSubscription && this.searchFieldsSubscription.unsubscribe()
    this.loadImageSubscription && this.loadImageSubscription.unsubscribe()
    this.loadReportSubscription && this.loadReportSubscription.unsubscribe()
    this.watchSubscription && this.watchSubscription.unsubscribe()
    this.resolveSubscription && this.resolveSubscription.unsubscribe()
  }

  componentDidUpdate(prevProps: OrderTrackingProps, prevState: OrderTrackingState) {
    if (this.state.searchField !== prevState.searchField ||
      this.state.searchText !== prevState.searchText ||
      this.state.showArchivedOrders !== prevState.showArchivedOrders ||
      this.state.sort !== prevState.sort ||
      this.state.filters !== prevState.filters ||
      this.state.pageNumber !== prevState.pageNumber) {
      this.refreshGrid()
    }
  }

  refreshGrid() {
    this.setState({ loading: true })
    this.subscription && this.subscription.unsubscribe()
    this.subscription = ResultsGridObservable({
      field: this.state.searchField,
      text: this.state.searchText,
      complete: this.state.showArchivedOrders,
      sort: this.state.sort,
      filters: this.state.filters,
      pageNumber: this.state.pageNumber,
      pageSize: PageSize,
      includeArchived: this.state.showArchivedOrders,
    }, this.props.isPortalAdmin ? 0 : AccountTypeID).subscribe(
      (data: OrderResultGridResponse) => this.setState({ data: data, loading: false, selectedTests: [] }),
      error => {
        this.setState({ loading: false })
        toast.error(error)
      }
    )
  }

  pageChanged = (pageNumber: number) => {
    this.setState({ pageNumber: pageNumber })
  }
  checkArchivedOrders(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ showArchivedOrders: e.target.checked, pageNumber: 1 })
  }
  sortGrid(column: string, order?: string) {
    this.setState({ sort: { column: column, order: order || "" }, pageNumber: 1 })
  }
  filterGrid(column: string, items: string[]) {
    this.setState(prevState => {
      const filters = [...prevState.filters]
      const filter = { column: column, values: items }
      let index = filters.findIndex(item => item.column === filter.column)
      if (index >= 0) {
        filters[index] = filter
      } else {
        filters.push(filter)
      }
      return { filters: filters, pageNumber: 1 }
    })
  }
  onSearch(searchField?: string, searchText?: string) {
    this.setState({ searchField: searchField || "", searchText: searchText || "", pageNumber: 1 })
  }
  onExportClick() {
    this.setState({ showExportOptions: true })
  }

  generateCCFImage = (image: RAImage, row: OrderResultRecord, canDownload: boolean) => {
    if (!canDownload) return
    this.loadImageSubscription && this.loadImageSubscription.unsubscribe()
    const data = {
      TestImageID: image.RAImageID,
      TestDetailID: row.TestDetailID,
      TestDetailClinicalID: row.TestDetailClinicalID || "",
      IsMarketPlace: true,
      TestDescription: image.Description
    }

    this.loadImageSubscription = ImageGet(data).subscribe(
      (data: ImageData) => this.processCCF(data),
      (error) => this.handleAPIError(error, {})
    )
  }

  isMroLetter = (item: RAImage) => item.Description == "MroLetter"
  isMroLetterRow = (row: OrderResultRecord) => row.RAImage?.filter(this.isMroLetter).length ?? 0 > 0 // assume there would be no multiple MRO images

  isMroCopy = (item: RAImage) => {
    if (!item.Description) {
      return false
    }
    const desc = item.Description.toLowerCase()
    return desc == "mrocopy"
  }
  isMroCopyRow = (row: OrderResultRecord) => {
    const mroImages = row.RAImage?.filter(this.isMroCopy)
    return (mroImages?.length ?? 0 > 0) // assume there would be no multiple MRO images
  }

  printMROReport = (row: OrderResultRecord) => {
    this.loadReportSubscription && this.loadReportSubscription.unsubscribe()

    const method = this.isMroLetterRow(row) ? GetMROLetter : GenerateMROReport

    this.loadReportSubscription = method(row.TestDetailID).subscribe(
      (data) => this.processReport(data),
      (error) => this.handleAPIError(error, {})
    )
  }

  processCCF = (data: ImageData) => {
    if (data && data.Base64String) {
      const currentDate = new Date()
      data.Base64String.forEach((item, index) => {
        const type = item.ImageType
        const fileName = FormatTimestampFileName("CCF_Image_Report" + index, type.split('/')[1], currentDate)
        const fileData = new Blob([FormatData(item.Base64Strings)], { type: type || data.ImageType })
        var fileURL = URL.createObjectURL(fileData)
        window.open(fileURL)
      })
    } else {
      toast.error("Service is not able to return CCF image for this record.")
    }
  }

  processReport = (data: string) => {
    if (data && data !== "") {
      const fileName = FormatTimestampFileName(this.props.implementationType === ImplementationTypeGovt ? "POCT_Report_" : "MRO_Report_", "pdf", new Date())
      const fileData = new Blob([FormatData(data)], { type: "application/pdf" })
      var fileURL = URL.createObjectURL(fileData)
      window.open(fileURL)
    } else {
      toast.error("Data not found.")
    }
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  handleAllTestDetailChange(e: React.ChangeEvent<HTMLInputElement>) {
    const selectedTests = e.target.checked && this.state.data && this.state.data.Records
      ? this.state.data.Records
        .map((rows: OrderResultRecord[]) => rows
          .map((row: OrderResultRecord) => ({ TestDetailID: row.TestDetailID, TestDetailClinicalID: row.TestDetailClinicalID, Archived: row.Reviewed })
          ))
      : []
    this.setState({ selectedTests: selectedTests.reduce((acc, val) => acc.concat(val), []) })
  }

  handleTestDetailChange = (row: OrderResultRecordIdentifier, checked: boolean) => {
    let selectedRows = [...this.state.selectedTests]

    const index = selectedRows.findIndex(item => item.TestDetailID === row.TestDetailID && item.TestDetailClinicalID === row.TestDetailClinicalID)
    if (index > -1) {
      selectedRows = [...selectedRows.slice(0, index), ...selectedRows.slice(index + 1)]
    } else {
      selectedRows.push(row)
    }
    this.setState({ selectedTests: selectedRows })
  }

  selectedReports = () => {
    return this.selectedResults().filter(r => this.iconsVisibility(r).MROReport).map(t => t.TestDetailID)
  }

  onPrintRecords = () => {
    this.setState({ printing: true })
    OrderResultsPrint({
      field: this.state.searchField,
      text: this.state.searchText,
      filters: this.state.filters,
      print: this.state.selectedTests,
    }, this.props.isPortalAdmin ? 0 : AccountTypeID).subscribe(
      (data: string) => {
        printPdf(data)
        this.setState({ printing: false })
      },
      error => this.handleAPIError(error, { printing: false })
    )
  }

  onPrintReports = () => {
    this.loadReportSubscription && this.loadReportSubscription.unsubscribe()
    this.setState({ printing: true })
    this.loadReportSubscription = GenerateMROReport(this.selectedReports().join(';')).subscribe(
      (data: string) => {
        this.processReport(data)
        this.setState({ printing: false })
      },
      error => this.handleAPIError(error, { printing: false })
    )
  }

  onOrderUpdated = () => {
    const formFoxVendoAN = this.state.details?.FormFoxVendorAN || 0
    if (formFoxVendoAN > 0) {
      this.setState({ showOrderEditModal: false, showAuthFormModal: false, eventDetails: false, showResendAuth: true, showSelectClinicEmail: false })
    } else {
      this.setState({ showOrderEditModal: false, showAuthFormModal: false, eventDetails: false, showResendAuth: false, showSelectClinicEmail: true })
    }
  }

  onCloseResend = () => {
    this.setState({ showResendAuth: false, details: undefined })
    this.refreshGrid()
  }
  onCloseResendEmail = () => {
    this.setState({ showSelectClinicEmail: false, details: undefined })
    this.refreshGrid()
  }

  handleWatchClick = () => {
    this.setState({ updatingWatchList: true })
    this.watchSubscription && this.watchSubscription.unsubscribe()
    this.watchSubscription = ResultsWatchObservable(
      this.selectedResults().map(item => item.TestEventID),
      this.props.LoginName
    ).subscribe(
      data => {
        this.setState({ updatingWatchList: false })
        toast.success(data)
        this.refreshGrid()
      },
      error => this.handleAPIError(error, { updatingWatchList: false })
    )
  }

  handleResolveClick = () => {
    const testData = this.selectedResults()?.map(test => ({
        TestEventID: test.TestEventID,
        AlertResolved: false,
        WatchResolved: true,
        TimingAlertResolved: false,
        ResultsAcknowledged: false
      })
    )
    this.setState({ resolving: true })
    this.resolveSubscription = ResultsResolveObservable(testData, this.props.LoginName).subscribe(
      data => {
        this.setState({ resolving: false })
        toast.success(data)
        this.refreshGrid()
      },
      error => this.handleAPIError(error, { resolving: false })
    )
  }

  showStatusModal = (data: OrderResultRecord) => this.setState({ statusInfo: true, details: data })
  showEmployeeDetails = (data: OrderResultRecord) => this.setState({ employeeDetails: true, details: data })
  showEventDetailsModal = (data: OrderResultRecord) => {
    this.setState({ eventDetails: true, details: data })
  }
  showEventDetailsCompareModal = (data: OrderResultRecord) => {
    this.setState({ eventCompare: true, details: data })
  }
  showAuthFormModal = (data: OrderResultRecord) => {
    if (data.FormFoxVendorAN > 0) {
      this.setState({ showAuthFormModal: true, showResendAuth: false, details: data, showSelectClinicEmail: false })
    } else {
      this.setState({ showAuthFormModal: false, showResendAuth: false, details: data, showSelectClinicEmail: true })
    }
  }
  showOrderEditModal = (data: OrderResultRecord) => this.setState({ showOrderEditModal: true, details: data })
  visibleColumns = () => this.state.columns.filter(col => col.visible)
  renderCell = (row: OrderResultRecord, colName: keyof OrderResultRecord, key: number, isFirstRow: boolean, isLastRow: boolean) => {
    switch (colName) {
      case "DonorID":
        return <td key={key} className={`align-text-top group-cell ${isFirstRow ? "first" : ""} ${isLastRow ? "last" : ""}`} style={{whiteSpace: "nowrap"}} onClick={() => this.showEmployeeDetails(row)}>
          {isFirstRow && <GridIDNumber value={row} />}
        </td>
      case "DonorName":
        return <td key={key} className={`align-text-top group-cell ${isFirstRow ? "first" : ""} ${isLastRow ? "last" : ""}`} style={{whiteSpace: "nowrap"}}>{isFirstRow && row[colName]}</td>
      case "Service":
        const showImageAlert = row.MockMergeFrom > 0 && row.MockTestEventAlertID > 0 && row.Alert && !row.AlertResolved
        const showImageAlertResolved = row.MockMergeFrom > 0 && row.MockTestEventAlertID > 0 && row.Alert && row.AlertResolved
        return <td key={key} className="align-text-top">
          <div style={{ display: 'flex', width: '100%', whiteSpace: "nowrap" }}>
            <Button variant="underline-link" onClick={() => this.showEventDetailsModal(row)}>{row[colName]}</Button>
            {showImageAlert && <img onClick={() => this.showEventDetailsCompareModal(row)} src={ImageAlert} alt={row.MergeFrom} title={row.MergeFrom} width="20px" height="20px" />}
            {showImageAlertResolved && <img src={ImageAlertResolved} alt={row.MergeFrom} title={row.MergeFrom} width="20px" height="20px" />}
          </div>
        </td>
      case "Status":
        return <td key={key} onClick={() => this.showStatusModal(row)} className="status-data align-text-top" style={{whiteSpace: "nowrap"}}>
          <GridStatusInfo value={row} showCompleteOrders={this.state.showArchivedOrders} />
        </td>
      case "SiteName":
        return <td key={key} className="align-text-top" style={{whiteSpace: "nowrap"}}>{row.SiteID ? `${row.SiteName} (${row.SiteID})` : row.Clinics ? row.Clinics : ""}</td>
      case "OrderedDate":
      case "EventDate":
      case "OrderUpdatedAt":
        return <td key={key} className="align-text-top" style={{whiteSpace: "nowrap"}}>{FormatDate(row[colName])}</td>
      case "DOT":
        return <td key={key} className="align-text-top" style={{whiteSpace: "nowrap"}}>{row[colName] ? "Yes" : "No"}</td>
      case "RAImageID":
        const iconsVisibility = this.iconsVisibility(row)
        return <td key={key} className="align-text-top" style={{whiteSpace: "nowrap"}}>
          {iconsVisibility.canView ? this.mapCCFImages(row, iconsVisibility.canDownload) : ""}
          {iconsVisibility.MROReport ? this.mapMROReport(row, iconsVisibility.MROStage) : ""}
        </td>
      case "FormFoxTestAN":
        return <td key={key} className="align-middle text-nowrap">
          <FormFoxTestANColumn row={row} showAuthFormModal={this.showAuthFormModal}/>
        </td>
      case "Result":
        return <td key={key} className="align-text-top" style={{whiteSpace: "nowrap"}}>{this.getResultText(row)}</td>
      case "Reason":
        return <td key={key} className="align-text-top" style={{whiteSpace: "nowrap"}}><ReasonForTestCell row={row}/></td>
      default:
        return <td key={key} className="align-text-top" style={{whiteSpace: "nowrap"}}>{row[colName] === "N/P" ? "Not Provided" : row[colName]}</td>
    }
  }

  getResultText = (row: OrderResultRecord) => {
    const result = row.Result || ""
    if (this.props.implementationType !== ImplementationTypeGovt) {
      return result
    }
    if (row.TestType !== ServiceTypeCode.Drug) {
      return result
    }
    if (result.toLowerCase() !== "positive") {
      return result
    }
    if (row.EventType.startsWith("QT") || row.Service.includes('POCT')) {
      return "POC-" + result
    }
    return result
  }

  iconsVisibility = (row: OrderResultRecord): ReportProps => {
    let result: ReportProps = { canView: false, canDownload: false, MROReport: false, MROStage: "" }

    if (this.isMroLetterRow(row)) {
      result.MROReport = true
    }
    if (this.isMroCopyRow(row)) {
      result.MROReport = true
    }
    if (this.props.implementationType === ImplementationTypeGovt) {
      if (row.TestType === ServiceTypeCode.Drug && row.Service.includes('POCT') && !!row.DateCollected) {
        result.MROReport = true
        result.MROStage = "POCT Letter Report"
      }
      // Display all available images in OnTrack with no restrictions
      result.canView = true
      result.canDownload = true
    }
    else {
      row.Stages.forEach((stage) => {
        if (row.TestType === ServiceTypeCode.Drug && stage.Sequence === 6) {
          result.canView = true
          result.canDownload = this.props.canVieweCCFCopy2PreMRO || false
          result.MROReport = stage.Status === 1
          result.MROStage = stage.Name
        }
        if (
          row.TestType === ServiceTypeCode.Drug
          && row.MROResultID === 0
          && [TestReleaseStatusID.LaboratoryTestingComplete, TestReleaseStatusID.LaboratoryTestingCompleteReleased].includes(row.TestReleaseStatusID)
          && stage.Sequence === 6
          && ((row.LabResultID === 3 && !row.MRONonDOTNeg) || (row.LabResultID !== 3 && !row.MRONonDOTPos))
        ) {
          result.canView = true
          result.canDownload = this.props.canVieweCCFCopy2PreMRO || false
          result.MROReport = true
          result.MROStage = "Laboratory Report"
        }

        if (row.TestType === ServiceTypeCode.Drug &&
          (row.IsPOCT || row.IsFLEX) &&
          row.MROResultID === 0 && row.LabResultID === 0
          && (row.TestReleaseStatusID === TestReleaseStatusID.PoctComplete
            || row.TestReleaseStatusID === TestReleaseStatusID.PoctCompleteReleased)
          && stage.Sequence === 3 && row.Result === "Negative") {
          result.canView = true
          result.canDownload = this.props.canVieweCCFCopy2PreMRO || false
          result.MROReport = true
          result.MROStage = "POCT Report"
        }

        if (row.TestType === ServiceTypeCode.Alcohol && (stage.Sequence === 3 || stage.Sequence === 4)) {
          result.canView = true
          result.canDownload = true
        }
        if (row.TestType === ServiceTypeCode.Physical) {
          if (stage.Sequence === 3) {
            result.canView = true
            result.canDownload = true
          }
        } else if (row.ServiceTypeCode === ServiceTypeCode.OHS) {
          if (stage.Sequence === 1 && (row.TestType === TestTypes.CRLCovidClearAntibody || row.TestType === TestTypes.CRLRapidResponseCovid)) {
            result.canView = true
            result.canDownload = true
          } else if (stage.Sequence === 3) {
            result.canView = true
            result.canDownload = true
          }
        }
        if (row.ServiceTypeCode === ServiceTypeCode.CHS)  {
          result.canView = true
          result.canDownload = true
        }
      })
    }
    return result
  }

  ccfImageDescription = (row: OrderResultRecord, item: RAImage) => {
    if (row.IsFLEX) {
      const upDescription = item.Description.toUpperCase()
      if (upDescription === "MROCOPY") {
        return "COPY2"
      }
    }
    //return row.IsFLEX && item.Description.toUpperCase() == "COPY2" ? "Instant Test Results Report" : item.Description
    return item.Description
  }

  isPositiveFlexInstantReport = (row: OrderResultRecord, item: RAImage) => {
    return row.IsFLEX && row.Result == "Positive" && item.Description == "COPY2"
  }
  mapCCFImages = (row: OrderResultRecord, canDownload: boolean) => {
    const imgSrc = row.ServiceTypeCode === ServiceTypeCode.OHS ? ImageOHS : ImageCCF
    return row.RAImage?.filter(i => !this.isMroLetter(i)).filter(i => !this.isPositiveFlexInstantReport(row, i)).map((item: RAImage) => <img key={item.RAImageID} onClick={() => this.generateCCFImage(item, row, canDownload)} src={imgSrc} alt={this.ccfImageDescription(row, item)} title={this.ccfImageDescription(row, item)} />)
  }

  mapMROReport = (row: OrderResultRecord, title: string) => <img onClick={() => this.printMROReport(row)} src={ImageMRO} alt={title} title={title} />

  selectedIdentifierByRow = (row: OrderResultRecord) => this.state.selectedTests.find(item => row.TestDetailID === item.TestDetailID && row.TestDetailClinicalID === item.TestDetailClinicalID)
  flattenResults = () => (this.state.data?.Records || []).reduce((acc, val) => acc.concat(val), [])
  selectedResults = () => this.flattenResults().filter(row => !!this.selectedIdentifierByRow(row))

  hideMergeEvent = () => {
    this.setState({ showMergeEvent: false })
  }

  onMergeEvent = () => {
    this.setState({ showMergeEvent: true })
  }

  render() {
    const testsSelected = this.state.selectedTests.length > 0
    const firstSelectedArchived = testsSelected && !!this.state.selectedTests[0].Archived
    const headerColumns = this.visibleColumns().map((col: Column, i) => {
      return (
        <th key={i}>
          {this.state.data && col.filter && col.filter in this.state.data && <ColumnHeaderFilter title={col.label || col.name}
            filtered={this.state.filters.findIndex(item => item.column === col.filter) >= 0}
            sort={this.state.sort && this.state.sort.column === col.name ? this.state.sort.order === "asc" ? "asc" : "desc" : undefined}
            items={this.state.data[col.filter as keyof ColumnFilters] || []}
            itemValueLabels={{ "N/P": "Not Provided" }}
            onSort={(order?: string) => this.sortGrid(col.name, order)}
            onFilter={(items: string[]) => col.filter && this.filterGrid(col.filter, items)}
            offsetTop={19}
          />}
          {(!this.state.data || !col.filter) && (col.label || col.name)}
        </th>
      )
    })
    const dataColumns = (row: OrderResultRecord, isFirstRow: boolean, isLastRow: boolean) => this.visibleColumns().map((col, i) => this.renderCell(row, col.name as keyof OrderResultRecord, i, isFirstRow, isLastRow))
    const printCell = (row: OrderResultRecord) => {
      const identifier = this.selectedIdentifierByRow(row)
      return <td className="pl-5" style={{ justifyContent: 'center', alignItems: 'center', verticalAlign: 'middle'}} key={`print-${row.TestDetailID}-${row.TestDetailClinicalID}`}>
        <OrderTrackingCheckbox idPrefix="td"
          item={identifier || { TestDetailID: row.TestDetailID, TestDetailClinicalID: row.TestDetailClinicalID, Archived: row.Reviewed }}
          checked={!!identifier}
          disabled={testsSelected && ((!row.Reviewed && firstSelectedArchived) || (row.Reviewed && !firstSelectedArchived))}
          onChange={this.handleTestDetailChange} />
      </td>
    }
    const groupedRows = (data: OrderResultGridResponse) => data.Records.map((rows: OrderResultRecord[]) => dataRows(rows))
    const dataRows = (rows: OrderResultRecord[]) => rows.map((row: OrderResultRecord, i: number) =>
      <tr key={i}>
        {printCell(row)}
        {this.props.implementationType !== ImplementationTypeGovt && <WatchCell row={row} />}
        {dataColumns(row, i === 0, i === rows.length - 1)}
      </tr>)


    const { loading, data, columns, showStatusModal, searchField, searchText, showAuthFormModal, showResendAuth,
      showOrderEditModal, showArchivedOrders, sort, filters, pageNumber, selectedTests, showExportOptions,
      customizeModal, completeModal, searchFields, statusInfo, employeeDetails,
      updatingWatchList, resolving,
      eventDetails, details, eventCompare, showMergeEvent, showSelectClinicEmail } = this.state

    const emptyRow = <tr><td colSpan={this.visibleColumns().length + 2}>NO DATA FOUND</td></tr>
    const allPrintChecked = !loading && !!data?.Records?.length && this.flattenResults().length === selectedTests.length
    return (
      <AppPageWrapper parentClassName={"align-items-center"} showNav={true}>
        <Container fluid className="grid-container pt-2">
          <Row>
            <Col className="px-0 pb-2">
              <Checkbox checked={showArchivedOrders} onChange={(e) => this.checkArchivedOrders(e)} label="Show Archived Orders" id="showCompletedOrders" />
            </Col>
          </Row>
          <Row className="pb-2">
            <Col className="px-0">
              <SearchBar allowBlank searchFields={searchFields || []} onSearch={(searchField?: string, searchText?: string) => { this.onSearch(searchField, searchText) }} formatValue={(id, value) => id === "SSN" ? FormatSSN(value) : value} />
            </Col>
            <Col lg={6} className="text-right p-0">
              {testsSelected && this.props.canCompleteEvents && <Button variant="secondary" size="sm" className="mr-1" onClick={() => this.setState({ completeModal: true })} >{firstSelectedArchived ? "UNARCHIVE" : "ARCHIVE"}</Button>}
              <ActionButton variant="secondary" size="sm" className="mr-1" onClick={this.handleWatchClick} disabled={selectedTests.length === 0} spin={updatingWatchList} disableOnSpin>WATCH</ActionButton>
              <ActionButton variant="secondary" size="sm" className="mr-1" onClick={this.handleResolveClick} disabled={selectedTests.length === 0} spin={resolving} disableOnSpin>RESOLVE</ActionButton>
              <Button variant="secondary" size="sm" className="mr-1" onClick={() => this.setState({ customizeModal: true })}>CUSTOMIZE</Button>
              <Button variant="secondary" size="sm" className="mr-1" onClick={() => this.onExportClick()}>
                EXPORT CSV&nbsp;
                <FaFileCsv />
              </Button>
              <Button variant="secondary" size="sm" className="mr-1" onClick={() => this.setState({ filters: [] })}>CLEAR FILTERS&nbsp;<FaSync /></Button>
              {this.props.implementationType === ImplementationTypeGovt && <Button variant="secondary" size="sm" className="mr-1" onClick={() => this.refreshGrid()}>REFRESH&nbsp;<FaSync /></Button>}
              {showExportOptions &&
                <ExportCSVModal
                  onClose={() => this.setState({showExportOptions: false})}
                  isPortalAdmin={this.props.isPortalAdmin}
                  searchParams={{field: this.state.searchField, text: this.state.searchText, sort: this.state.sort, filters: this.state.filters}}
                />}
              {statusInfo && details && <ModalStatusInfo details={details} onHide={() => this.setState({ statusInfo: false })} />}
              {showAuthFormModal && details && <ConnectedAuthFormModal details={details} onEdit={this.showOrderEditModal} onHide={() => this.setState({ showAuthFormModal: false, details: undefined })} />}
              {showResendAuth && details && <ConnectedAuthFormModal details={details} isAfterUpdate onHide={this.onCloseResend} />}
              {showSelectClinicEmail && details && <SendSelectClinicLink details={details} isAfterUpdate onHide={this.onCloseResendEmail} />}
              {showOrderEditModal && details && <OrderEditModal
                details={details}
                onHide={() => this.setState({ showOrderEditModal: false })}
                onOrderUpdated={this.onOrderUpdated} />}
              {employeeDetails && details && <EmployeeDetailsModal
                showService
                details={details}
                personID={details.PersonID}
                name={details.DonorName}
                id={details.DonorID || details.SSN}
                onHide={(updated) => this.setState({ employeeDetails: false }, () => updated && this.refreshGrid())}
                isGov={this.props.implementationType === ImplementationTypeGovt}
              />}
              {eventDetails && details && <EventDetailsModal
                details={details}
                onRefreshGrid={() => this.refreshGrid()}
                onHide={(updated) => this.setState({ eventDetails: false }, () => updated && this.onOrderUpdated())}
                onMerge={this.onMergeEvent} />}
              {eventCompare && details && <EventDetailsCompare details={details} onRefreshGrid={() => this.refreshGrid()} onHide={() => this.setState({ eventCompare: false })} />}
              <ColumnsCustomizeModal show={customizeModal}
                columns={columns}
                storeKey={StorageKey.OrderTrackingGridColumns}
                onClose={() => this.setState({ customizeModal: false })}
                onSave={(columns) => this.setState({ columns: columns as Column[], customizeModal: false })} />
              {completeModal && <CompleteModal
                unarchive={firstSelectedArchived}
                show={completeModal}
                onHide={() => this.setState({ completeModal: false })}
                onSave={() => this.refreshGrid()}
                selectedTests={this.selectedResults().map(item => ({ TestEventID: item.TestEventID, TestDetailID: item.TestDetailID, TestDetailClinicalID: item.TestDetailClinicalID || "", PersonID: item.PersonID, HireDate: undefined, PoolID: null, Images: [], DonorName: item.DonorName, AuthorizationID: item.FormFoxTestAN }))}
              />}
              {showMergeEvent && details &&
                <SearchTestToMerge
                  details={details} onHide={this.hideMergeEvent}
                />}
            </Col>
          </Row>
          <Row>
            <Col className="px-0">
              <HorizontalScrollWrapper
                gridRef={this.gridRef}
                recalculateWidth={!loading && !customizeModal}
                visible={this.state.data && this.state.data?.Total > 0}
                offsetVertical={330}
              >
                <Table bordered className="mb-0" ref={this.gridRef}> 
                  <thead>
                    <tr>
                      <th className="text-center print-column">
                        {!showArchivedOrders && <Checkbox id="printSelectAll" checked={allPrintChecked} onChange={(e) => this.handleAllTestDetailChange(e)} />}
                        <PrintFormModal
                          disabled={selectedTests.length === 0}
                          hasReports={this.selectedReports().length > 0}
                          printing={this.state.printing}
                          onPrintRecords={() => this.onPrintRecords()}
                          onPrintReports={() => this.onPrintReports()}
                        />
                      </th>
                      {this.props.implementationType !== ImplementationTypeGovt && <th className="alert-icons">WATCH</th>}
                      {headerColumns}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      loading ?
                        <tr>
                          <td colSpan={this.visibleColumns().length + 2} className="align-middle text-center">
                            <div className="d-flex justify-content-center text-secondary" style={{ width: "100vw" }}>
                              <Spinner animation="border" variant="secondary" role="status" className="mr-2" />
                              <span>Loading...</span>
                            </div>
                          </td>
                        </tr> :
                        data?.Records && data.Records.length > 0 ? groupedRows(data) : emptyRow
                    }
                  </tbody>
                </Table>
              </HorizontalScrollWrapper>
            </Col>
          </Row>
          {!loading && data && (
            <Row>
              <Col>
                <span className="total-records">Total records: {data.Total}</span>
                <TablePagination pageNumber={pageNumber} pages={data.Pages} onChange={this.pageChanged} />
              </Col>
            </Row>
          )}
        </Container>
      </AppPageWrapper>
    )
  }
}

function mapStateToProps(state: AppState): OrderTrackingProps {
  const getImplementationType = () => sessionStorage.getItem("implementationType") || ""
  const userAccess = BuildUserAccess(state)
  return {
    isPortalAdmin: isPortalAdmin(state),
    canCompleteEvents: userAccess.canCompleteEvents,
    canVieweCCFCopy2PreMRO: userAccess.canVieweCCFCopy2PreMRO,
    LoginName: getLoggedInUserName(state),
    implementationType: getImplementationType(),
  }
}
const ConnectedRandomPools = connect(mapStateToProps, null)(OrderTracking)
export default ConnectedRandomPools
